import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import './gp-web-basket.css'

export default class GPWebBasket extends Component {
  render() {
    const { t, editHandler, basket: {currencySymbol, totalPrice} } = this.props

    /* eslint-disable */
    return (
      <div className="basket">
        <div className="basket__content">
          <div className='basket__header'>
            <p className="basket__title">{t('GP_CONFIRM_PAY')}</p>
          </div>

          <ul className='basket__list'>
            <li className='basket__list_item'>
              {t('GP_CHK_PLAN_1_TITLE')}
            </li>
          </ul>

          <div className='basket__footer'>
            <p className="basket__total">{t('GP_TOTAL')}</p>
            <span className='basket__price'>{`${currencySymbol}${totalPrice}`}/{t('GP_MONTH')}</span>
          </div>

        </div>
      </div>
    )
    /* eslint-enable */
  }
}

GPWebBasket.propTypes = {
  t: PropTypes.func.isRequired,
}

GPWebBasket.defaultProps = {
}




// WEBPACK FOOTER //
// ./src/components/gp-web-basket/gp-web-basket.js